export default {
  approval() {
    return {
      data: {
        'app-id': 'BA094051-5307-4CFB-9103-C54004FCC376',
        'cif-number': '1000101203',
        'installment-amount-total': '20000',
        'no-of-installments': '48',
        'first-name': 'Lilibeth',
        'last-name': 'Perez',
        'full-name': 'Lilibeth Sarmiento Perez',
        gender: 'F',
        dob: '16121978',
        nationality: 'PH',
        'emirates-id': '784197895818613',
        income: '5000',
        'passport-number': 'P8313584A',
        'passport-expiry': '10082028',
        'previous-passport-number': null,
        'mobile-number': '971565870543',
        'subject-id': null,
        status: 'ELIGIBLE',
        message: 'credit in approval range',
      },
    };
  },
};
